<template>
  <div>
    <div >
      <InputSearch class="mb-3" @clickSearch="onSearch" :search="search" :placeholder="'ค้นหา'" />
      <v-layout row wrap dense class="mb-3">
        <v-flex xs6 style="display: flex; align-items: center">
          <Typography h2 bold :label="`ตราสัญลักษณ์`" />
        </v-flex>
        <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
          <div class="text-xs-right" style="display: flex; align-items: flex-end">
            <v-btn
              variant="outlined"
              v-tooltip="'เพิ่ม'"
              :loading="loading"
              @click="showAddModal"
              icon
              color="#BECCDB"
              style="border-radius: 50% !important"
            >
              <img src="/static/img/Add.png" alt class="responsive-img" style="height: 20px" />
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="symbols"
          :disable-initial-sort="true"
          hide-actions
          select-all
          item-key="name"
          class="fixTable"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="(header, k) in props.headers"
                :key="header.text + k"
              >
                <div>
                  {{ header.text }}
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr v-if="props.item.levels.length === 0">
              <td class="text-left">
                <Typography
                  style="width: 160px; overflow-wrap: break-word"
                  h5
                  :label="props.item.id"
                />
              </td>
              <td class="text-left">
                <Typography
                  style="width: 160px; overflow-wrap: break-word"
                  h5
                  :label="props.item.name"
                />
              </td>
              <td class="text-xs-center">
                <div style="width: 170px; padding: 12px 0">
                  <v-img
                    @click="
                      showImg = true
                      showImgUrl = props.item.image_url
                    "
                    :src="props.item.image_url || ''"
                    width="70%"
                    height="70%"
                  />
                </div>
              </td>
              <td></td>
              <td></td>
              <td style="white-space: nowrap" @click.stop="">
                <TooltipTable
                  @modalEdit="updateEditSymbol(props.item)"
                  @Delete="deleteBadges(props.item.id)"
                  :datas="props"
                  showDelete
                ></TooltipTable>
              </td>
            </tr>
            <tr
              v-else
              class="py-3 depatable"
              v-for="(level, index) in props.item.levels"
              :key="index"
            >
              <td v-if="index === 0" class="text-left" :rowspan="props.item.levels.length || 1">
                <Typography
                  style="width: 160px; overflow-wrap: break-word"
                  h5
                  :label="props.item.id"
                />
              </td>
              <td v-if="index === 0" class="text-left" :rowspan="props.item.levels.length || 1">
                <Typography
                  style="width: 160px; overflow-wrap: break-word"
                  h5
                  :label="props.item.name"
                />
              </td>
              <td
                v-if="index === 0"
                class="text-xs-center"
                :rowspan="props.item.levels.length || 1"
              >
                <div style="width: 170px; padding: 12px 0">
                  <v-img
                    @click="
                      showImg = true
                      showImgUrl = props.item.image_url
                    "
                    :src="props.item.image_url || ''"
                    width="70%"
                    height="70%"
                  />
                </div>
              </td>
              <td class="text-left">
                <Typography
                  style="width: 160px; overflow-wrap: break-word"
                  h5
                  :label="level.level"
                />
              </td>
              <td class="text-xs-center">
                <div style="width: 170px; padding: 12px 0">
                  <v-img
                    @click="
                      showImg = true
                      showImgUrl = level.image_url
                    "
                    :src="level.image_url || ''"
                    width="70%"
                    height="70%"
                  />
                </div>
              </td>
              <td
                v-if="index === 0"
                style="white-space: nowrap"
                @click.stop=""
                :rowspan="props.item.levels.length || 1"
              >
                <TooltipTable
                  @modalEdit="updateEditSymbol(props.item)"
                  @Delete="deleteBadges(props.item.id)"
                  :datas="props"
                  showDelete
                ></TooltipTable>
              </td>
            </tr>
          </template>
        </v-data-table>
        <Paginations
          @clickPagination="changepage"
          @sortPage="sortPage"
          :numberPage="numberPage"
          :pageCount="pageCount"
          :page="page"
        />
        <v-dialog v-model="addModal" persistent width="590px">
          <v-card v-if="addModal">
            <v-btn
              style="float: right"
              @click="
                addModal = false
                cancelAddModal = true
              "
              icon
              ><v-icon>close</v-icon></v-btn
            >
            <v-card-text
              ><Typography h2 bold :label="`เพิ่มตราสัญลักษณ์`" style="padding-left: 54px"
            /></v-card-text>
            <v-card-actions>
              <div
                style="width: 100%"
                class="form-control px-3"
                :class="{ 'has-error': errors.has('ชื่อตราสัญลักษณ์') }"
              >
                <label
                  ><Typography h5 semiBold color="color-darkGrey" :label="`ชื่อตราสัญลักษณ์`"
                /></label>
                <input
                  type="search"
                  class="depainput rsu mb-0"
                  style="padding-left: 12px !important"
                  name="ชื่อตราสัญลักษณ์"
                  v-validate="'required'"
                  placeholder=""
                  v-model="newSymbol.name"
                />
                <span class="text-error" v-if="errors.has('ชื่อตราสัญลักษณ์')">{{
                  errors.first('ชื่อตราสัญลักษณ์')
                }}</span>
              </div>
            </v-card-actions>
            <v-card-actions style="padding-left: 5px !important" class="pb-0">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  gap: 8px;
                  overflow: hidden;
                "
                class="pl-3"
              >
                <v-radio-group v-model="newSymbol.isLevel" row class="mt-0">
                  <v-radio color="primary" label="มีระดับ" :value="true"></v-radio>
                  <v-radio color="primary" label="ไม่มีระดับ" :value="false"></v-radio>
                </v-radio-group>
              </div>
            </v-card-actions>
            <v-card-actions class="pt-0" style="flex-direction: column; align-items: flex-start">
              <div v-if="newSymbol.isLevel" style="width: 100%">
                <div
                  v-for="(level, index) in newSymbol.levels"
                  :key="index"
                  style="width: 100%"
                  class="form-control px-3 mb-3"
                  :class="{ 'has-error': errors.has(`ไฟล์ภาพ-${index + 1}`) }"
                >
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <Typography
                      h5
                      semiBold
                      color="color-darkGrey"
                      :label="`ระดับ ${level.level}`"
                    />
                    <v-btn
                      v-if="newSymbol.levels.length > 1"
                      icon
                      @click="removeLevel(index)"
                      style="margin-left: 5px !important"
                    >
                      <img
                        src="/static/img/garbage.svg"
                        alt
                        class="responsive-img"
                        style="height: 18px"
                      />
                    </v-btn>
                  </div>
                  <uploadfile
                    v-validate="'required'"
                    :name="`ไฟล์ภาพ-${index + 1}`"
                    :key="`ไฟล์ภาพ-${index + 1}`"
                    :height="120"
                    :index="index"
                    backgroundSize="contain"
                    v-model="level.image_url"
                  ></uploadfile>
                  <span class="text-error" v-if="errors.has(`ไฟล์ภาพ-${index + 1}`)">{{
                    errors.first(`ไฟล์ภาพ-${index + 1}`)
                  }}</span>
                </div>
                <div class="text-xs-right" style="display: flex; align-items: center">
                  <v-btn icon @click="addLevel" style="margin-left: 5px !important">
                    <img
                      src="/static/img/addBlue.svg"
                      alt
                      class="responsive-img"
                      style="height: 20px"
                    />
                  </v-btn>
                  <Typography h5 semiBold color="color-darkBlue" :label="`เพิ่มระดับ`" />
                </div>
              </div>
              <div v-else style="width: 100%">
                <div
                  style="width: 100%"
                  class="form-control px-3 mb-3"
                  :class="{ 'has-error': errors.has(`รูปภาพ`) }"
                >
                  <Typography h5 semiBold color="color-darkGrey" :label="`รูปภาพ`" />
                  <uploadfile
                    v-validate="'required'"
                    name="รูปภาพ"
                    key="รูปภาพ"
                    :height="120"
                    backgroundSize="contain"
                    v-model="newSymbol.image_url"
                  ></uploadfile>
                  <span class="text-error" v-if="errors.has(`รูปภาพ`)">{{
                    errors.first(`รูปภาพ`)
                  }}</span>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions style="justify-content: center" class="pb-3">
              <div class="text-xs-center rsu">
                <v-btn
                  class="rsu"
                  @click="
                    addModal = false
                    cancelAddModal = true
                  "
                  round
                  small
                  outline
                  color="primary"
                >
                  <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
                </v-btn>
                <v-btn
                  class="rsu"
                  :loading="saveloading"
                  @click="saveData"
                  round
                  small
                  depressed
                  style="color: yellow"
                  color="primary"
                  ><Typography h5 semiBold color="color-lightYellow" :label="$t('Save')"
                /></v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="editModal" persistent width="590px">
          <v-card v-if="editModal">
            <v-btn style="float: right" @click="editModal = false" icon
              ><v-icon>close</v-icon></v-btn
            >
            <v-card-text
              ><Typography h2 bold :label="`แก้ไขตราสัญลักษณ์`" style="padding-left: 54px"
            /></v-card-text>
            <v-card-actions>
              <div
                style="width: 100%"
                class="form-control px-3"
                :class="{ 'has-error': errors.has('ชื่อตราสัญลักษณ์') }"
              >
                <label
                  ><Typography h5 semiBold color="color-darkGrey" :label="`ชื่อตราสัญลักษณ์`"
                /></label>
                <input
                  type="search"
                  class="depainput rsu mb-0"
                  style="padding-left: 12px !important"
                  name="ชื่อตราสัญลักษณ์"
                  v-validate="'required'"
                  placeholder=""
                  v-model="editSymbol.name"
                  :disabled="hasbadge"
                />
                <span class="text-error" v-if="errors.has('ชื่อตราสัญลักษณ์')">{{
                  errors.first('ชื่อตราสัญลักษณ์')
                }}</span>
              </div>
            </v-card-actions>
            <v-card-actions style="padding-left: 5px !important" class="pb-0">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  gap: 8px;
                  overflow: hidden;
                "
                class="pl-3"
              >
                <v-radio-group v-model="editSymbol.isLevel" row class="mt-0" :disabled="hasbadge">
                  <v-radio color="primary" label="มีระดับ" :value="true"></v-radio>
                  <v-radio color="primary" label="ไม่มีระดับ" :value="false"></v-radio>
                </v-radio-group>
              </div>
            </v-card-actions>
            <v-card-actions class="pt-0" style="flex-direction: column; align-items: flex-start">
              <div v-if="editSymbol.isLevel" style="width: 100%">
                <div
                  v-for="(level, index) in editSymbol.levels"
                  :key="index"
                  style="width: 100%"
                  class="form-control px-3 mb-3"
                  :class="{ 'has-error': errors.has(`ไฟล์ภาพ-${index + 1}`) }"
                >
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <Typography
                      h5
                      semiBold
                      color="color-darkGrey"
                      :label="`ระดับ ${level.level}`"
                    />
                    <v-btn
                      v-if="editSymbol.levels.length > 1 && !hasbadge"
                      icon
                      @click="removeEditLevel(index)"
                      style="margin-left: 5px !important"
                    >
                      <img
                        src="/static/img/garbage.svg"
                        alt
                        class="responsive-img"
                        style="height: 18px"
                      />
                    </v-btn>
                  </div>
                  <uploadfile
                    v-validate="'required'"
                    :name="`ไฟล์ภาพ-${index + 1}`"
                    :key="`ไฟล์ภาพ-${index + 1}`"
                    :height="120"
                    :index="index"
                    backgroundSize="contain"
                    v-model="level.image_url"
                  ></uploadfile>
                  <span class="text-error" v-if="errors.has(`ไฟล์ภาพ-${index + 1}`)">{{
                    errors.first(`ไฟล์ภาพ-${index + 1}`)
                  }}</span>
                </div>
                <div class="text-xs-right" style="display: flex; align-items: center">
                  <v-btn
                    icon
                    @click="addEditLevel"
                    style="margin-left: 5px !important"
                    :disabled="hasbadge"
                  >
                    <img
                      v-if="!hasbadge"
                      src="/static/img/addBlue.svg"
                      alt
                      class="responsive-img"
                      style="height: 20px"
                    />
                    <img
                      v-else
                      src="/static/img/addBlueOpacity.svg"
                      alt
                      class="responsive-img"
                      style="height: 20px"
                    />
                  </v-btn>
                  <Typography
                    v-if="!hasbadge"
                    h5
                    semiBold
                    color="color-darkBlue"
                    :label="`เพิ่มระดับ`"
                  />
                  <Typography
                    v-else
                    h5
                    semiBold
                    color="color-darkBlue-opacity"
                    :label="`เพิ่มระดับ`"
                  />
                </div>
              </div>
              <div v-else style="width: 100%">
                <div
                  style="width: 100%"
                  class="form-control px-3 mb-3"
                  :class="{ 'has-error': errors.has(`รูปภาพ`) }"
                >
                  <Typography h5 semiBold color="color-darkGrey" :label="`รูปภาพ`" />
                  <uploadfile
                    v-validate="'required'"
                    name="รูปภาพ"
                    key="รูปภาพ"
                    :height="120"
                    backgroundSize="contain"
                    v-model="editSymbol.image_url"
                  ></uploadfile>
                  <span class="text-error" v-if="errors.has(`รูปภาพ`)">{{
                    errors.first(`รูปภาพ`)
                  }}</span>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions style="justify-content: center" class="pb-3">
              <div class="text-xs-center rsu">
                <v-btn
                  class="rsu"
                  @click="
                    editModal = false
                    cancelEditModal = true
                  "
                  round
                  small
                  outline
                  color="primary"
                >
                  <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
                </v-btn>
                <v-btn
                  class="rsu"
                  @click="
                    saveEditModal = true
                    editModal = false
                  "
                  round
                  small
                  depressed
                  style="color: yellow"
                  color="primary"
                  ><Typography h5 semiBold color="color-lightYellow" :label="$t('Save')"
                /></v-btn>
              </div>
            </v-card-actions> </v-card
        ></v-dialog>
        <v-dialog v-model="cancelAddModal" width="430px">
          <v-card v-if="cancelAddModal"
            ><div class="text-xs-right">
              <v-btn
                icon
                @click="
                  cancelAddModal = false
                  addModal = true
                "
                ><v-icon>close</v-icon></v-btn
              >
            </div>
            <v-card-text>
              <Typography h2 bold center :label="`ออกจากหน้านี้`" style="margin-bottom: 5px" />
              <Typography
                h5
                medium
                center
                style="padding: 0px 60px"
                :label="
                  `คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้ หากกด ยืนยัน ข้อมูลที่กรอกไว้จะหายไปทันที`
                "
              />
            </v-card-text>
            <v-card-actions style="justify-content: center" class="pb-3">
              <div class="text-xs-center rsu mb-3">
                <v-btn
                  class="rsu"
                  @click="
                    addModal = true
                    cancelAddModal = false
                  "
                  round
                  small
                  outline
                  color="primary"
                >
                  <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
                </v-btn>
                <v-btn
                  class="rsu"
                  @click="closeAddModal"
                  round
                  small
                  depressed
                  style="color: yellow"
                  color="primary"
                  ><Typography h5 semiBold color="color-lightYellow" :label="$t('Confirm')"
                /></v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="cancelEditModal" width="430px">
          <v-card v-if="cancelEditModal"
            ><div class="text-xs-right">
              <v-btn
                icon
                @click="
                  cancelEditModal = false
                  editModal = true
                "
                ><v-icon>close</v-icon></v-btn
              >
            </div>
            <v-card-text>
              <Typography h2 bold center :label="`ออกจากหน้านี้`" style="margin-bottom: 5px" />
              <Typography
                h5
                medium
                center
                style="padding: 0px 60px"
                :label="
                  `คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้ หากกด ยืนยัน ข้อมูลที่กรอกไว้จะไม่ถูกบันทึก`
                "
              />
            </v-card-text>
            <v-card-actions style="justify-content: center" class="pb-3">
              <div class="text-xs-center rsu mb-3">
                <v-btn
                  class="rsu"
                  @click="
                    editModal = true
                    cancelEditModal = false
                  "
                  round
                  small
                  outline
                  color="primary"
                >
                  <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
                </v-btn>
                <v-btn
                  class="rsu"
                  @click="closeEditModal"
                  round
                  small
                  depressed
                  style="color: yellow"
                  color="primary"
                  ><Typography h5 semiBold color="color-lightYellow" :label="$t('Confirm')"
                /></v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="saveEditModal" width="430px">
          <v-card v-if="saveEditModal"
            ><div class="text-xs-right">
              <v-btn
                icon
                @click="
                  saveEditModal = false
                  editModal = true
                "
                ><v-icon>close</v-icon></v-btn
              >
            </div>
            <v-card-text>
              <Typography h2 bold center :label="`บันทึก`" style="margin-bottom: 10px" />
              <Typography
                h5
                bold
                center
                style="padding: 0px 60px; margin-bottom: 10px"
                :label="`รายการสินค้าบน TechHunt ที่มีตราสัญลักษณ์นี้ จะถูกแก้ไขทั้งหมด`"
              />
              <Typography
                h5
                medium
                center
                style="padding: 0px 60px"
                :label="`คุณแน่ใจหรือไม่ว่าต้องการบันทึกรายการนี้`"
              />
            </v-card-text>
            <v-card-actions style="justify-content: center" class="pb-3">
              <div class="text-xs-center rsu mb-3">
                <v-btn
                  class="rsu"
                  @click="
                    saveEditModal = false
                    editModal = true
                  "
                  round
                  small
                  outline
                  color="primary"
                >
                  <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
                </v-btn>
                <v-btn
                  class="rsu"
                  :loading="saveloading"
                  @click="saveEditData"
                  round
                  small
                  depressed
                  style="color: yellow"
                  color="primary"
                  ><Typography h5 semiBold color="color-lightYellow" :label="$t('Confirm')"
                /></v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showImg" width="800px">
          <v-card v-if="showImg">
            <div class="text-xs-right">
              <v-btn icon @click="showImg = false"><v-icon>close</v-icon></v-btn>
            </div>
            <div><v-img :src="showImgUrl || ''"></v-img></div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import InputSearch from '@/components/elements/InputSearch.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import uploadfile from '@/components/elements/uploadfiletest.vue'
import Paginations from '@/components/elements/Paginations.vue'
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'

export default {
  components: {
    InputSearch,
    TooltipTable,
    uploadfile,
    Paginations,
    Typography
  },

  data() {
    return {
      loading: false,
      saveloading: false,
      addModal: false,
      cancelAddModal: false,
      cancelEditModal: false,
      saveEditModal: false,
      editModal: false,
      hasbadge: false,
      page: 1,
      numberPage: {
        page: undefined
      },
      limit: 10,
      showImgUrl: '',
      showImg: false,
      search: { nameAll: '' },
      newSymbol: {
        name: '',
        isLevel: false,
        image_url: '',
        levels: [
          {
            level: 1,
            image_url: ''
          }
        ]
      },
      editSymbol: {},
      symbols: [],
      symbolsTotal: 0,
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        {
          text: 'ชื่อตราสัญลักษณ์',
          align: 'left',
          value: 'name'
        },
        {
          text: 'รูปภาพ',
          align: 'left',
          value: 'image_url'
        },
        {
          text: 'ระดับ',
          align: 'left',
          value: 'levels_level'
        },
        {
          text: 'รูปภาพแต่ละระดับ',
          align: 'left',
          value: 'levels_image_url'
        },
        {
          text: '',
          align: 'center',
          value: ''
        }
      ]
    }
  },
  async mounted() {
    this.loading = true
    const { data, total } = await this.getBadges()
    this.symbolsTotal = total
    this.symbols = data.map(ele => ({
      id: ele.id,
      name: ele.name,
      image_url: ele.image_url,
      levels: ele.levels === null ? [] : ele.levels
    }))
    this.loading = false
  },
  computed: {
    pageCount() {
      if (this.symbolsTotal !== 0) {
        let count = Math.ceil(this.symbolsTotal / this.limit)
        return count
      } else {
        return 0
      }
    }
  },
  methods: {
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      const { data, total } = await this.getBadges()
      this.symbolsTotal = total
      this.symbols = data.map(ele => ({
        id: ele.id,
        name: ele.name,
        image_url: ele.image_url,
        levels: ele.levels === null ? [] : ele.levels
      }))
      this.loading = false
    },
    async sortPage(pages) {
      if (pages == '' || +pages <= 0 || +pages > this.pageCount) return
      this.page = parseInt(pages)
      this.loading = true
      const { data, total } = await this.getBadges()
      this.symbolsTotal = total
      this.symbols = data.map(ele => ({
        id: ele.id,
        name: ele.name,
        image_url: ele.image_url,
        levels: ele.levels === null ? [] : ele.levels
      }))
      this.loading = false
    },
    async onSearch() {
      this.loading = true
      this.page = 1
      this.numberPage.page = 1
      const { data, total } = await this.getBadges()
      this.symbolsTotal = total
      this.symbols = data.map(ele => ({
        id: ele.id,
        name: ele.name,
        image_url: ele.image_url,
        levels: ele.levels === null ? [] : ele.levels
      }))
      this.loading = false
    },
    async onUpdate() {
      this.loading = true
      if (this.page) {
        this.numberPage.page = this.page
      }
      const { data, total } = await this.getBadges()
      this.symbolsTotal = total
      this.symbols = data.map(ele => ({
        id: ele.id,
        name: ele.name,
        image_url: ele.image_url,
        levels: ele.levels === null ? [] : ele.levels
      }))
      this.loading = false
    },
    async updateEditSymbol(item) {
      const res = await api.checkProductBadgeById({ badgeid: item.id })
      if (res.responsecode == 300) {
        this.hasbadge = true
      } else {
        this.hasbadge = false
      }
      this.editModal = true
      this.editSymbol = {
        ...item,
        levels:
          item.levels.length === 0
            ? [
                {
                  level: 1,
                  image_url: ''
                }
              ]
            : item.levels,
        isLevel: item.levels.length === 0 ? false : true
      }
    },
    showAddModal() {
      this.addModal = true
    },
    closeAddModal() {
      this.newSymbol = {
        name: '',
        isLevel: false,
        image_url: '',
        levels: [
          {
            level: 1,
            image_url: ''
          }
        ]
      }
      this.addModal = false
      this.cancelAddModal = false
    },
    closeEditModal() {
      this.editModal = false
      this.cancelEditModal = false
    },
    addLevel() {
      this.newSymbol.levels.push({ level: this.newSymbol.levels.length + 1, image_url: '' })
    },
    addEditLevel() {
      this.editSymbol.levels = [
        ...this.editSymbol.levels,
        { level: this.editSymbol.levels.length + 1, image_url: '' }
      ]
    },
    removeLevel(index) {
      const newSymbols = this.newSymbol.levels.filter(level => level.level !== index + 1)
      this.newSymbol.levels = newSymbols.map((ele, index) => ({
        level: index + 1,
        image_url: ele.image_url
      }))
    },
    removeEditLevel(index) {
      const editSymbols = this.editSymbol.levels.filter(level => level.level !== index + 1)
      this.editSymbol.levels = editSymbols.map((ele, index) => ({
        level: index + 1,
        image_url: ele.image_url
      }))
    },
    async getBadges() {
      try {
        const data = {
          limit: this.limit,
          offset: (this.page - 1) * this.limit,
          nameAll: this.search.nameAll
        }
        return await api.getBadges(data)
      } catch (e) {
        console.log(e)
      }
    },
    async saveData() {
      var isValid = await this.$validator.validate()
      if (isValid) {
        try {
          if (this.newSymbol.isLevel) {
            delete this.newSymbol.isLevel
            this.saveloading = true
            await api.addBadges({ ...this.newSymbol, image_url: null })
            this.newSymbol = {
              name: '',
              isLevel: false,
              image_url: '',
              levels: [
                {
                  level: 1,
                  image_url: ''
                }
              ]
            }
            this.saveloading = false
            this.addModal = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            await this.onUpdate()
          } else {
            delete this.newSymbol.isLevel
            delete this.newSymbol.levels
            this.saveloading = true
            await api.addBadges(this.newSymbol)
            this.newSymbol = {
              name: '',
              isLevel: false,
              image_url: '',
              levels: [
                {
                  level: 1,
                  image_url: ''
                }
              ]
            }
            this.saveloading = false
            this.addModal = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            await this.onUpdate()
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    async saveEditData() {
      var isValid = await this.$validator.validate()
      if (isValid) {
        try {
          if (this.editSymbol.isLevel) {
            delete this.editSymbol.isLevel
            this.saveloading = true
            await api.editBadges(this.editSymbol.id, { ...this.editSymbol, image_url: null })
            this.saveloading = false
            this.saveEditModal = false
            this.editModal = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            await this.onUpdate()
          } else {
            delete this.editSymbol.isLevel
            delete this.editSymbol.levels
            this.saveloading = true
            await api.editBadges(this.editSymbol.id, this.editSymbol)
            this.saveloading = false
            this.saveEditModal = false
            this.editModal = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            await this.onUpdate()
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    async deleteBadges(id) {
      const res = await api.checkProductBadgeById({ badgeid: id })
      if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          title: `<div class="headline primary--text bold7 fs-24">ไม่สามารถลบข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้ตราสัญลักษณ์นี้อยู่</div>`,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      } else {
        this.$swal
          .fire({
            title:
              '<img src="/static/img/delete.png" alt class="responsive-img mt-4" style="height: 73px" />',
            html: `<div class="primary--text fs-16 mt-2 mb-3" style="font-weight:600;">คุณต้องการลบข้อมูลตราสัญลักษณ์นี้ใช่หรือไม่</div>`,
            showCancelButton: true,
            showCloseButton: true
          })
          .then(async result => {
            if (result.value) {
              let res = await api.deleteBadges(id)
              if (this.symbols.length == 1) {
                if (this.page != 1) {
                  this.page = this.page - 1
                  this.numberPage.page = this.page - 1
                }
              }
              await this.onUpdate()
              if (res.status === 200) {
                this.$swal.fire({
                  type: 'success',
                  title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                })
              } else {
                this.$swal.fire({
                  type: 'error',
                  title:
                    '<div class="headline primary--text bold7 fs-24">ไม่สามารถลบข้อมูลได้ เนื่องจากมีโครงการที่กำลังใช้ตราสัญลักษณ์นี้อยู่</div>',
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                })
              }
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table.v-table tbody tr td::after {
  content: '';
  border-left: 1px solid #d9d9d9;
  position: absolute;
  height: 50%;
  left: 0;
  top: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectSymbol.vue